<template>
  <el-dialog :title="$t('acceptPayments.create_static_qr')" class="diglog-card" :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px" @close="initData">
    <div class="header-line" />
    <el-form ref="form" :model="form" label-width="90px" :rules="rules" label-position="left" class="form-contaniner">
      <el-form-item :label="$t('system.remark')" prop="remark">
        <el-input v-model="form.remark" size="small" maxlength="200" type="textarea" :placeholder="$t('acceptPayments.enter_remark')" class="search-frame" autocomplete="off" clearable />
      </el-form-item>
      
      <el-form-item :label="$t('acceptPayments.tag')" prop="tag">
        <el-input v-model="form.tag" size="small" maxlength="25" :placeholder="$t('acceptPayments.enter_tag')" class="search-frame" autocomplete="off" clearable />
      </el-form-item>

      <p>{{ $t('tips.create_static_qr_tips') }}</p>

      <p style="color: #ccc">{{ $t('acceptPayments.example') }}</p>

      <div style="display: flex;justify-content: center;margin-top: 20px;">
        <div style="width: 300px;position: relative;">
          <div v-html="qrStandName" class="merchant-name"/>
          <img src="@/assets/img/qr_stand_bg.png" class="qr-stand-bg" />
        </div>
      </div>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button>
      <el-button type="info" :disabled="listLoading" @click="onSubmit('form')">{{ $t('components.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { PostCreateMchOnboardQr } from '@/api/accept-payments/accept-payments'

export default {
  data() {
    const checkTag = (rule, value, callback) => {
      if (value) {
        const regex = new RegExp('^[0-9a-zA-Z]{1,25}$')
        if (!regex.test(value)) {
          return callback(new Error('Numbers and English letters only, up to 25 characters'))
        }
      }

      return callback()
    }
    return {
      dialogVisible: false,
      listLoading: false,
      form: {
        remark: '',
        tag: ''
      },
      rules: {
        tag: [
          { validator: checkTag, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    qrStandName() {
      let fontSize = '30px'
      const name = this.form.tag || this.$store.state.user.mainUserName
      if (name.length > 14) {
        fontSize = '15px'
      }
      return `<span style="font-size: ${fontSize}">${name}</span>`
    }
  },
  methods: {
    initData() {
      this.form = {}
      this.$nextTick(()=>{
        this.$refs['form'].clearValidate()
      })
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.listLoading = true
          const params = {
            remark: this.form.remark,
            tag: this.form.tag
          }
          PostCreateMchOnboardQr(params).then(res => {
            this.$alert(this.$t('tips.after_create_static_qr_tips'), this.$t('components.tips'), {
              confirmButtonText: this.$t('components.confirm')
            })
            this.$emit('updateTableData')
            this.dialogVisible = false
          }).finally(() => {
            this.listLoading = false
          })
        }
      })
    },
    openModal() {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.form-contaniner{
  margin: 20px 0 0;
}
.qr-stand-bg {
  width: 100%;
}
.merchant-name {
  padding: 0 10px;
  color: #000000;
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 30px;
  font-weight: bold;
  line-height: 15px;
  width: 100%;
  height: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  /* max-width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}
</style>
